<template>
  <div>
    <el-row>
      <TableContainer
        expand
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        showReviewOption
        ref="TableContainer"
      >
        <template v-slot:tools>
          <router-link :to="'/schedulingStart'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">开始排课</el-button>
          </router-link>
        </template>

        <template v-slot:expand="{props}">
          <div class="table_expand">
            <div class="table_expand__title">
                绑定的课程
            </div>
            <template v-for="(item,index) in props.row.courses">
              <div class="table_expand__item" :key="index">
                <div class="table_expand__title"><b>课程名：</b>  {{item.title}}</div>
                <div class="table_expand__teacher"><b>讲师：</b>  {{item.teacher}}</div>
              </div>              
            </template>
            <template v-if="props.row.courses.length == 0">
                <p class="font_asset">无绑定的课程</p>
            </template>
          </div>            
        </template>

        <template v-slot:filter>
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="onDateChanged"
          ></el-date-picker>
          <StudyClassSelect @onValueChanged="onStudyClassValueChanged"></StudyClassSelect>          
          <UnitCascader v-if="isAdmin" @onValueChanged="onUnitValueChanged"></UnitCascader>
          <PartyOrgCascader v-if="isAdmin" @onValueChanged="onPartyOrgValueChanged"></PartyOrgCascader>
 
        </template>

        <!--  -->
        <template v-slot:table__footer__info>排课列表</template>
      </TableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>

<script>
import { TableContainer } from "@/core/table/";

import { StudyClassSelect,UnitCascader,PartyOrgCascader } from "@/views/components/select"


export default {
  name: "schedulinglocation",
  props:{
    timetype:{
      type: Number
    }
  },
  components: {
    StudyClassSelect,UnitCascader,PartyOrgCascader,TableContainer
  },
  data() {
    return {
      containerTableColumns : [
      {
          prop: "cdate",
          label: "创建时间",
          width: "180px"
        },
        {
          prop: "sctitle",
          label: "所属学习班"
        },
        {
          prop: "displayDate",
          label: "排课日期",
          width: "200px"
        },
        {
          prop: "addresses",
          label: "上课地址",
          width: "200px"
        },
        {
          prop: "credithour",
          label: "学时",
          width: "50px"
        }
      ],
       // 基础地址
      containerBaseUrl : "/standard/scheduling",
      // api的基础地址
      // eslint-disable-next-line no-undef
      containerServerUrl :  "/api/manager/scheduling",
      // table config 设置
      tableToolConfig : {
        canEdit: true,
        canRecover: true,
        canDelete: true,
        canDisable: true
      },

      isAdmin: false ,

      date: ""
    };
  },
  methods:{
      onStudyClassValueChanged(sid){
        this.$refs.TableContainer.updateSid(sid);
      },

      onUnitValueChanged(ids){

        console.log("ids",ids)

        this.$refs.TableContainer.updateParams("units",ids);
      },

      onPartyOrgValueChanged(ids){
        this.$refs.TableContainer.updateParams("partyids",ids);
      },

      onDateChanged(date){
        this.$refs.TableContainer.updateParams("date",this.date);
      }
  },
  mounted(){
    this.isAdmin = this.$store.getters['profileModule/isadmin'];
    console.log("mounted store isadmin",this.isAdmin)


  }
};

</script>


<style scoped>
</style>